/**
 * ImportPreviewErrorTooltip — envolve o StatusDot com um Tooltip exibindo o
 * motivo legível da invalidação/falha quando houver `errorMessage`.
 *
 * Padrão compartilhado entre previews de Negócios, Afiliados e Contatos.
 *
 * RELEASE:
 *   2026-05-17 v1.0.0 - Componente compartilhado.
 */
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ImportPreviewStatusDot } from './ImportPreviewStatusDot';

interface ImportPreviewErrorTooltipProps {
  colorClass: string;
  label: string;
  errorMessage?: string | null;
}

export function ImportPreviewErrorTooltip({
  colorClass,
  label,
  errorMessage,
}: ImportPreviewErrorTooltipProps) {
  // Sem motivo de erro, mantém o dot simples.
  if (!errorMessage) {
    return <ImportPreviewStatusDot colorClass={colorClass} label={label} />;
  }

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="cursor-help focus:outline-none"
            aria-label={`Status: ${label}. Motivo: ${errorMessage}`}
          >
            <ImportPreviewStatusDot colorClass={colorClass} label={label} />
          </button>
        </TooltipTrigger>
        <TooltipContent side="left" className="max-w-xs text-xs leading-relaxed">
          {errorMessage}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
